import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View } from 'dripsy';
import React, { useContext } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';

import { ModalView } from '@/design-system/components/modal/ModalView';
import { UniNativeModal } from '@/design-system/components/modal/nativeModal/UniNativeModal';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { ReplaceCardWebScreen } from './ReplaceCardWeb.screen';
import { ReplaceCardNativeScreen } from './ReplaceCardNative.screen';
import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';

export interface ReplaceCardProps {}
export const ReplaceCardScreen: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.ReplaceCard>> = ({
  navigation
}) => {
  const layout = useContext(LayoutContext);
  const { useModalProps, closeModal } = useModalView({});
  const onGoBack = () => {
    navigation.goBack();
  };
  if (layout.isMobile) {
    return (
      <View sx={stylesNative.containerNative}>
        <UniNativeModal onBack={onGoBack} showHeader={false}>
          <UtxAppEmbed>
            <ReplaceCardNativeScreen onClose={closeModal} />
          </UtxAppEmbed>
        </UniNativeModal>
      </View>
    );
  }

  return (
    <ModalView useModalProps={useModalProps} minWidth={500}>
      <ReplaceCardWebScreen onClose={closeModal} />
    </ModalView>
  );
};

enum StyleNameNative {
  containerNative = 'containerNative'
}

const stylesNative: Record<StyleNameNative, SxProp> = {
  containerNative: {
    flex: 1,
    height: '100%',
    backgroundColor: 'transparent'
  }
};
